/**
 * User-facing validation messages for the Coverage Details footer
 * "Continue" button's disabling conditions (see
 * `coverageInfo/coverageDetails/components/coverageDetailsFooter.tsx`).
 *
 * Each key maps 1:1 to a condition that can disable the button, so the same
 * message can be reused in tooltips, banners, toasts, or help text anywhere
 * in the app.
 *
 * @module coverageDetailsValidationMessages
 */
export enum CoverageDetailsValidationMessages {
  // The coverage form is in edit mode with unsaved changes
  COVERAGE_EDITING = "Coverage changes require saving or discarding",
}
